import { render, staticRenderFns } from "./B-2-1-1__NavigationEdit.vue?vue&type=template&id=619b8583&"
import script from "./B-2-1-1__NavigationEdit.vue?vue&type=script&lang=js&"
export * from "./B-2-1-1__NavigationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
